<template>
<main-content>
    <kt-panel>
        <kt-panel-body v-if="ip_location !== 'IR'">
            <div class="alert alert-danger" role="alert">
                {{ $t('label.ir_ip_error') }}
            </div>
        </kt-panel-body>
        <kt-panel-body v-else>
            <payman-form :form_data="form_data" :submit="submit"></payman-form>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import PaymanForm from './components/form'
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { paymanService, ipApi } from '@/common/api.service'

export default {
    components: {
        'main-content': mainContent,
        'payman-form': PaymanForm
    },
    computed: {
        form_data: {
            get: function() {
                return this.$store.state.payman.form_data
            },
            set: function(value) {
                this.$store.commit('payman/setFormData', value)
            }
        }
    },
    data() {
        return {
            ip_location: '',
        }
    },
    mounted() {
        ipApi.ipLocation().then(response => {
            this.ip_location = response.data.countryCode;
        })
    },
    methods: {
        submit(e) {
            this.form_data.merchant_share_percent = $('#merchant_wage').val()
            let form = $('#payman_form')
            let btn = $('#submit_btn')
            form.validate({
                rules: {
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    subcategory_code: {
                        required: true,
                    },
                    address: {
                        required: true,
                    },
                    telephone: {
                        required: true
                    },
                    logo: {
                        required: true
                    },
                    sheba_number: {
                        required: true
                    },
                    merchant_share_percent: {
                        required: true
                    },
                    site_address: {
                        required: true,
                        url: true
                    },
                }
            })

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)

            let params = this.$store.getters['payman/form_data']
            paymanService.create(params).then(response => {
                this.$router.push('/gateways')
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTApp.unprogress(btn)
            })
        },
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.commit('payman/clearFormData')
        })
    },
}
</script>

<style>

</style>